import React, { useEffect, useState } from "react";
import BreadCrumb from "../_partials/breadCrumb";
import SkillHeaderDetails from "../_partials/skillHeaderDetails";
import { useLocation } from "react-router-dom";

const CreateSkill = (props) => {
  const { botType } = props;
  const location = useLocation();

  const [skillBotType, setSkillBotType] = useState("")

  const [skillStoreForm, setskillStoreForm] = useState({
    Name: "",
    Description: "",
    ShortDescription: "",
    DepartmentNameId: 0,
    LookupSkillScopeId: 0,
    PublishOn: "",
    Acurracy: "",
    AvgExecutionTime: "",
    IsThirdPartyAITool: false,
    functions: [],
    subFunctions: [],
    tags: [],
    Owner: [],
    Contact: [],
    ChatBotURL: "",
    InputType: botType === 'configure' ? 'text' : null,
    OutputType: null,
    LastMessagesCount: botType === 'configure' ? "10" : null,
    ChatGPTVersion: null,
    IsChatbotTestable: null,
    ShowCitation: null,
    ShowFollowUpQuestions: null,
    CurlRequestString: null,
    UserAssistantMessageFormat: null,
    FileType: null,
    ChatbotUIView: null,
    DynamicProperties: [],
    SecurityGroupId: "",
    IsUsingWrapperAPIURL: null,
    WrapperAPIURL: null,
    CitationURL: null,
    CitationParams: null,
    ImageURL: null,
    ImageParams: null,
    SkillResources: [],
    SkillModels: [],
    IsVisibleToUser: false,
    IsFabricAI: botType === 'configure' ? true : false,
    IsIndexCreated: false,
  });

  const [skillBotConfiguration, setskillBotConfiguration] = useState({
    Purpose: "",
    Tone: "",
    Persona: "",
    SimpleChatBot: false,
    PDFWithImages: false,
    PDFWithText: false,
    Files: [],
    SkillStoreId: null,
  });


  useEffect(() => {
    if (botType) {
      setSkillBotType(botType);
    }
  }, [botType]);

  return (
    <div className="dashboard-wrapper">
      <div className="">
        <BreadCrumb skillStoreName="Create Skill" />
        <SkillHeaderDetails
          skillStoreForm={skillStoreForm}
          setskillStoreForm={setskillStoreForm}
          botType={skillBotType}
          skillBotConfiguration={skillBotConfiguration}
          setskillBotConfiguration={setskillBotConfiguration}
        />
      </div>
    </div>
  );
};

export default CreateSkill;